import React from 'react';
import classNames from 'classnames/bind';
import styles from './JoinIdentifyNotice.module.scss';

const cx = classNames.bind(styles);

function JoinItendifyNotice() {
	return (
		<>
			<strong className={cx('tit')}>꼭 알아두세요!</strong>
			<ul className={cx('list')}>
				<li>고객님 명의로 등록된 인증수단과 정보를 입력해 주셔야 합니다.</li>
				<li>본인인증 시 발생되는 고객님의 비용부담은 없습니다.</li>
				<li>본인인증에 관한 문의는 NICE신용평가정보 고객지원센터(1600-1522)로 연락 주시기 바랍니다.</li>
			</ul>
		</>
	);
}

export default JoinItendifyNotice;
